function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-icon_barcode"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_barcode",
  clipPath: "url(#clip-icon_barcode)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_barcode-2",
  "data-name": "icon_barcode"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon_barcode_square_1063",
  "data-name": "\\uC0AC\\uAC01\\uD615 1063",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1420",
  "data-name": "\\uD328\\uC2A4 1420",
  d: "M.5,0h.7a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(3 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1419",
  "data-name": "\\uD328\\uC2A4 1419",
  d: "M.5,0h.7a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(7.1 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1418",
  "data-name": "\\uD328\\uC2A4 1418",
  d: "M.5,0h.7a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(11.2 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1417",
  "data-name": "\\uD328\\uC2A4 1417",
  d: "M.5,0h.7a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(15.2 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1416",
  "data-name": "\\uD328\\uC2A4 1416",
  d: "M.5,0h.7a.5.5,0,0,1,.5.5v13a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0Z",
  transform: "translate(19.3 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1415",
  "data-name": "\\uD328\\uC2A4 1415",
  d: "M.4,0A.4.4,0,0,1,.8.4V13.6a.4.4,0,0,1-.8,0V.4A.4.4,0,0,1,.4,0Z",
  transform: "translate(5.5 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1414",
  "data-name": "\\uD328\\uC2A4 1414",
  d: "M.4,0A.4.4,0,0,1,.8.4V13.6a.4.4,0,0,1-.8,0V.4A.4.4,0,0,1,.4,0Z",
  transform: "translate(9.6 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1413",
  "data-name": "\\uD328\\uC2A4 1413",
  d: "M.4,0A.4.4,0,0,1,.8.4V13.6a.4.4,0,0,1-.8,0V.4A.4.4,0,0,1,.4,0Z",
  transform: "translate(13.7 5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_barcode_path__1412",
  "data-name": "\\uD328\\uC2A4 1412",
  d: "M.4,0A.4.4,0,0,1,.8.4V13.6a.4.4,0,0,1-.8,0V.4A.4.4,0,0,1,.4,0Z",
  transform: "translate(17.7 5)"
})));

var SvgBarcode = function SvgBarcode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarcode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/barcode.d89ebca4.svg";
export { ForwardRef as ReactComponent };